export const SVG_FORMAT_KEY = "svg";
export const SVG_XML_FORMAT_KEY = "svg+xml";
export const SVG_FORMAT_KEYS = [SVG_FORMAT_KEY, SVG_XML_FORMAT_KEY];
export const PNG_FORMAT_KEY = "png";
export const JPEG_FORMAT_KEY = "jpeg";
export const JPG_FORMAT_KEY = "jpg";

export const SVG_LOGO_TYPE = "image/svg+xml";
export const JPEG_IMAGE_TYPE = "image/jpeg";
export const ALL_IMAGE_TYPE = "image/*";

export const PDF_FILE_TYPE = "application/pdf";
export const PREVIEWABLE_FORMATS = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/svg",
  "image/svg+xml",
  "image/webp",
];

export const FORMAT_MAP = {
  "svg+xml": "svg",
  postscript: "eps",
  illustrator: "ai",
};

export const CREATE_SHOP_ADD_LOGO_MODAL_CONFIG = {
  title: "Add Your Logo",
  description: "We will use your logo to generate assets for your shop.",
  primaryFooterCtaText: "Generate Assets",
  secondaryFooterCtaText: "Skip for now",
};

export const getShopEditLogoModalConfig = ({ isCatalogLogo = false, isLogoAdded = false }) => ({
  title: `${isLogoAdded ? "Edit" : "Add"} ${isCatalogLogo ? "Swag" : "Shop"} Logo`,
  description: "",
  primaryFooterCtaText: "Save",
});

const heroBannerWidth = 2880;
const heroBannerHeight = 910;

export const BANNER_FILE_DETAILS = {
  dimensions: `${heroBannerWidth}px X ${heroBannerHeight}px`,
  fileSizeInMb: 10,
  fileSizeInBytes: 10 * 1024 * 1024,
};

export const LOGO_FILE_DETAILS = {
  dimensions: "20px X 14px",
  fileSizeInMb: 5,
  fileSizeInBytes: 5 * 1024 * 1024,
};

export const BRANDED_GUIDELINES_FILE_FORMATS = ["pdf", "jpg", "png", "docx"];

export const SUPPORTED_FILE_FORMATS = {
  simple: ["svg", "png", "webp", "jpeg", "jpg", "svg+xml"],
  complex: ["ai", "eps"],
};

export const RECOMMENDED_FILE_FORMATS = ["ai", "svg", "eps"];

// * Lower number is Higher precedence
export const LOGO_FORMAT_PRECEDENCE = {
  [SVG_FORMAT_KEY]: 1,
  [SVG_XML_FORMAT_KEY]: 2,
  [PNG_FORMAT_KEY]: 3,
  [JPEG_FORMAT_KEY]: 4,
  [JPG_FORMAT_KEY]: 5,
};

export const LOGO_DPI_QUALITY = {
  POOR: "Poor",
  OK: "Ok",
  GOOD: "Good",
};

export const LOGO_DPI_QUALITY_DISPLAY = {
  [LOGO_DPI_QUALITY.POOR]: { label: "Poor quality", color: "#da1e28" },
  [LOGO_DPI_QUALITY.OK]: { label: "Ok quality", color: "#ffb800" },
  [LOGO_DPI_QUALITY.GOOD]: { label: "Good quality", color: "#226104" },
};

export const LOGO_HIGH_QUALITY_NOTE_URL =
  "https://help.bystadium.com/hc/en-us/articles/36768461849879-Best-Logo-File-Formats-for-Swag-Printing-and-Decoration";
